import { createFileRoute } from '@tanstack/react-router';
import { MeTodayPage } from '@/features/team/pages/me-today-page';

export const Route = createFileRoute('/_app/me/today')({ component: MeTodayPage });
